import * as yup from 'yup';
export const CreateEntityFormValidation = yup.object().shape({
  description: yup.string().required("Campo é obrigatório"),
});
